import React from "react";
import vv11 from "../../assets/14.png";
import vv12 from "../../assets/15.png";
import vv13 from "../../assets/16.png";
import vv14 from "../../assets/17.png";
import "./footer.css";
import {VirtualHost} from "../../constants";

function Footer() {
  return (
    <footer className="u-clearfix u-footer u-grey-80 full-w" id="sec-c3c1">
      <div className="u-clearfix u-sheet u-sheet-1">
        <div className="u-align-left u-social-icons u-spacing-37 u-social-icons-1">
          {VirtualHost.companyFacebookAddress &&
              <a className="u-social-url" title="facebook" target="_blank" href={VirtualHost.companyFacebookAddress}>
            <span className="u-file-icon u-icon u-social-facebook u-social-icon u-text-white u-icon-1">
              <img src={vv11} alt=""/>
            </span>
              </a>}

          {VirtualHost.companyTwitterAddress &&
              <a className="u-social-url" title="twitter" target="_blank" href={VirtualHost.companyTwitterAddress}>
            <span className="u-file-icon u-icon u-social-icon u-social-twitter u-text-white u-icon-2">
              <img src={vv12} alt=""/>
            </span>
              </a>}

          {VirtualHost.companyTwitterAddress &&
              <a className="u-social-url" title="instagram" target="_blank" href={VirtualHost.companyTwitterAddress}>
            <span className="u-file-icon u-icon u-social-icon u-social-instagram u-text-white u-icon-3">
              <img src={vv13} alt=""/>
            </span>
              </a>}
          {/*<a className="u-social-url" title="linkedin" target="_blank" href="">*/}
          {/*  <span className="u-file-icon u-icon u-social-icon u-social-linkedin u-text-white u-icon-4">*/}
          {/*    <img src={vv14} alt="" />*/}
          {/*  </span>*/}
          {/*</a>*/}
        </div>
        <div className="u-border-1 u-border-white u-expanded-width u-line u-line-horizontal u-opacity u-opacity-50 u-line-1"></div>
        <p className="u-align-left u-text u-text-1 footer-copyright">
          {" "}
          © 2022 {VirtualHost.companyAddressName} &amp; Kırmızı Kurumsal | Tüm hakları
          saklıdır.
        </p>
      </div>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/component/Footer/index.js